module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAACAQMAAACuUVQjAAAABlBMVEV+fn7///9Z83ptAAAADElEQVQI12OoY6gDAAH8AP1kotnBAAAAAElFTkSuQmCC"